export enum UserSettingsCategory {
    General = "general",
    Security = "security",
    Billing = "billing"
}